import React, { useState, useEffect } from "react";
import TextField from "../../../Components/UI/Inputs/TextField";
import Password from "../../../Components/UI/Inputs/Password";
import Button from "../../../Components/UI/Buttons/Button";
import DropDown from "../../../Components/UI/Inputs/DropDown";
import showToast from "../../../Helpers/toast";
import NavigateButton from "../../../Components/UI/Buttons/NavigateButton";
import useApi from "../../../Hooks/useApi";
import { useNavigate } from "react-router-dom";
import MultiLocationSelector from "../../../Components/UI/Inputs/LocationSelector/LocationSelectorContainer";
import { handleApiError } from "../../../Helpers/ErrorHandler";
import Common from "../../../Components/Layouts/Common";

const AddIMISUser = ({}) => {
  const initialFormState = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirm_password: "",
    userType: "",
  };
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialFormState);

  const [roles, setRoles] = useState([]);
  const [errors, setErrors] = useState(null);
  const { loading, request } = useApi();

  const [locations, setLocations] = useState([]);
  const [allLocation, setAllLocation] = useState([]);
  const fetchLocations = async () => {
    try {
      const response = await request("GET", "/v1/locations", {});
      if (response?.length > 0) {
        setAllLocation(response);
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [rolesData] = await Promise.all([request("GET", "/v1/roles")]);

        setRoles(rolesData);
      } catch (error) {
        setErrors(error);
      }
    };

    fetchData();
  }, [request]);

  const handleInputChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    let data = { ...formData };

    if (
      !data.email
        ?.trim()
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      setErrors({ message: "Invalid email" });
      showToast({ message: "Please provide a valid email!", type: "error" });
      return false;
    }

    if (!data.userType?.name) {
      setErrors({ message: "User-Type is required!" });
      showToast({ message: "Please select a user-type", type: "error" });
      return false;
    }
    if (data.password && data.confirm_password) {
      if (data.password !== data.confirm_password) {
        setErrors({ message: "Passwords do not match" });
        showToast({ message: "Passwords do not match!", type: "error" });
        return false;
      }
      if (data.password.trim() < 6) {
        setErrors({ message: "Passwords is too short!" });
        showToast({ message: "Passwords is too short!", type: "error" });
      }
    } else {
      setErrors({ message: "Enter and Confirm password" });
      showToast({ message: "Enter and Confirm password", type: "error" });
      return false;
    }

    delete data.confirm_password;
    return data;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = validate();

    if (data) {
      data.userType = data?.userType?.value;
      if (
        locations.length &&
        formData.userType?.name == "IMIS Data Insertion"
      ) {
        data.locations = locations?.map((item) => item.id);
      }
      if (formData.userType?.name == "IMIS Data Insertion") {
        delete formData.departmentId;
        delete formData.designationId;
      }
      try {
        const response = await request("POST", "/v1/user/imis", {
          data: {
            ...data,
          },
        });

        showToast({ message: response?.message || "User Added Successfully!" });
        navigate("/manage-users");
        setFormData(initialFormState);
      } catch (error) {
        showToast({
          message:
            error?.response?.data?.message || "Error Occurred! Try again.",
          type: "error",
        });

        setErrors(error);
      }
    }
  };

  return (
    <div className="px-2 h-full">
      <Common headline={"Add IMIS User"}>
        <div className=" grid lg:grid-cols-2  gap-2">
          <TextField
            label="First Name"
            name="firstName"
            onValueChange={handleInputChange}
            value={formData.firstName}
          />

          <TextField
            label="Last Name"
            name="lastName"
            onValueChange={handleInputChange}
            value={formData.lastName}
          />
          <TextField
            label="Email"
            name="email"
            onValueChange={handleInputChange}
            value={formData.email}
          />

          <DropDown
            label="Role"
            placeholder={"Select Role"}
            name="userType"
            baggage={true}
            onValueChange={(value) => handleInputChange("userType", value)}
            value={formData.userType}
            options={roles
              .map((role) => ({
                name: role.name,
                value: role.id,
              }))
              .filter((item) => item.name?.toLowerCase()?.includes("imis"))}
          />

          {formData.userType?.name == "IMIS Data Insertion" ? (
            <div className="col-span-full">
              <MultiLocationSelector
                locationList={allLocation}
                locations={locations}
                setLocations={setLocations}
              />
            </div>
          ) : (
            <></>
          )}
          <Password
            label="Password"
            name="password"
            onValueChange={handleInputChange}
            value={formData.password}
          />

          <Password
            label="Confirm Password"
            name="confirm_password"
            onValueChange={handleInputChange}
            value={formData.confirm_password}
          />

          <div className="col-span-2 flex justify-center">
            <Button
              type="full"
              label={loading ? "Submitting..." : "Submit"}
              textColor="white"
              backgroundColor="#7DDBFF"
              handler={handleSubmit}
              style={{ width: "200px"}}
              disabled={loading}
            />
          </div>
        </div>
      </Common>
    </div>
  );
};
export default AddIMISUser;
